// src/pages/Reports/components/TicketDeliveryDetailModal.tsx
// Mục 15.c/15.d, README_UPDATE.md — modal bọc TicketDeliveryDetailTable, dùng cho nút "Xem chi
// tiết" của báo cáo giao vé đại lý (lọc theo agentId) và báo cáo kỳ phát hành (lọc theo planId).

import React from 'react';
import { Modal, ModalBody, ModalHeader, Button, ModalFooter } from 'reactstrap';
import TicketDeliveryDetailTable from './TicketDeliveryDetailTable';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_components');

interface TicketDeliveryDetailModalProps {
  isOpen: boolean;
  title: string;
  planId?: number;
  agentId?: number;
  showAgentColumn?: boolean;
  getAgentLabel?: (agentId: number) => string;
  onClose: () => void;
}

const TicketDeliveryDetailModal: React.FC<TicketDeliveryDetailModalProps> = ({
  isOpen,
  title,
  planId,
  agentId,
  showAgentColumn,
  getAgentLabel,
  onClose,
}) => (
  <Modal isOpen={isOpen} toggle={onClose} centered size="xl" scrollable>
    <ModalHeader toggle={onClose}>{title}</ModalHeader>
    <ModalBody>
      <TicketDeliveryDetailTable
        planId={planId}
        agentId={agentId}
        showAgentColumn={showAgentColumn}
        getAgentLabel={getAgentLabel}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>
        {st('dong_button')}
      </Button>
    </ModalFooter>
  </Modal>
);

export default TicketDeliveryDetailModal;
